module.exports = __webpack_public_path__ + "static/media/33-iveco.9dd23d64.jpg";